// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21sWv","textarea":"styles_textarea__iDeqF"};